export default "__VITE_ASSET__1ad3e4b6__"